module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "labelList-wrapper"
  }, [_c('ul', {
    staticClass: "labelList"
  }, _vm._l((_vm.labelList), function(item) {
    return _c('li', {
      style: ({
        background: item.color
      })
    }, [_vm._v(_vm._s(item.label))])
  })), _c('ul', {
    staticClass: "labelList-detail"
  }, _vm._l((_vm.labelList), function(item) {
    return _c('li', [_c('div', {
      style: (_vm._f("labelStyle")(item))
    }, [_vm._v(_vm._s(item.label))]), _vm._l((item.children), function(child) {
      return _c('div', {
        style: (_vm._f("labelStyle")(child))
      }, [_vm._v(_vm._s(child.label))])
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-222f7a69","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/MeterReading/Schedule/LabelList.vue
// module id = 1715
// module chunks = 1